import React, { useState } from 'react'
import i18n from 'i18n-js'

import './EHPCalculator.scss'

import DefaultForm from './DefaultForm/DefaultForm'
import DepthForm from './DepthForm/DepthForm'

const DEFAULT_FORM = 'DEFAULT_FORM'
const DEPTH_FORM = 'DEPTH_FORM'

const EHPCalculator = () => {

    const [isWelcome, setIsWelcome] = useState(true)
    const [formType, setFormType] = useState(DEFAULT_FORM)

    const onToggleForm = type => {
        setIsWelcome(false)
        setFormType(type)
    }

    return <section className="EHPCalculator">
        <h1 className="main-title">{i18n.t('welcome_title')}</h1>
        {isWelcome && <>
            <p className="sub-title">{i18n.t('welcome_subtitle')}</p>
            <h2 className="sub-title">{i18n.t('what_is')}</h2>
            <p className="sub-title">{i18n.t('ehp_description')}</p>
        </>}
        <p className="formula">EHP = HP*(1140+(DEF*3.5))/1000</p>
        {isWelcome && <>
            <p className="sub-title">{i18n.t('choose_from_options')}</p>
            <ul className="list">
                <li className="d-flex align-items-center" onClick={() => onToggleForm(DEFAULT_FORM)}>
                    {i18n.t('option_1')}
                </li>
                <li onClick={() => onToggleForm(DEPTH_FORM)}>
                    {i18n.t('option_2')}
                    <span className="tip">({i18n.t('tip')})</span>
                </li>
            </ul>
        </>}
        {!isWelcome && formType === DEFAULT_FORM && <DefaultForm back={() => setIsWelcome(true)} />}
        {!isWelcome && formType === DEPTH_FORM && <DepthForm back={() => setIsWelcome(true)} />}
    </section>
}

export default EHPCalculator